import { render, staticRenderFns } from "./VenueCardSmall.vue?vue&type=template&id=64833d00&scoped=true&"
import script from "./VenueCardSmall.vue?vue&type=script&lang=js&"
export * from "./VenueCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./VenueCardSmall.vue?vue&type=style&index=0&id=64833d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64833d00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
